import { HEADING_TYPES } from "./constants";
import type { HeadingType } from "./constants";

export const isHeadingType = (value: string): value is HeadingType =>
  HEADING_TYPES.includes(value as HeadingType);
